'use client';

import { Box, useTheme } from '@mui/material';
import { avatarTone, mailboxName } from '@/lib/inbox/display';

type Props = {
  label: string;
  full?: boolean;
  size?: 'sm' | 'md';
  /** Colours from Gmail. Without them the tag takes the colour made from its name. */
  tone?: { bg: string; fg: string };
};

export default function MailboxTag({ label, full = false, size = 'md', tone: ownTone }: Props) {
  const nameTone = avatarTone(label, useTheme().palette.mode === 'dark');
  const tone = ownTone ?? nameTone;
  const small = size === 'sm';
  return (
    <Box
      component="span"
      title={label}
      sx={{
        display: 'inline-block',
        alignSelf: 'center',
        flexShrink: 0,
        minWidth: 0,
        maxWidth: full ? '100%' : 112,
        ...(small && { width: 64, textAlign: 'center' }),
        height: small ? 18 : 24,
        px: small ? 0.75 : 1.125,
        borderRadius: small ? '6px' : 999,
        bgcolor: tone.bg,
        color: tone.fg,
        fontSize: small ? '0.6875rem' : '0.75rem',
        fontWeight: 600,
        letterSpacing: '0.01em',
        lineHeight: small ? '18px' : '24px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {full ? label : mailboxName(label)}
    </Box>
  );
}
